import { Text } from 'components/Atoms';
import React from 'react';

const index = () => {

  const year = new Date().getFullYear();

  return (
    <Text color="gray" weight="semibold" size="header" align="center">
      Copyright © 2017 - {year} Flixxo - Suite 23 Portland House, Glacis Road, Gibraltar
    </Text>
  )
}

export default index
